
      var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgError = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 120,
  height: 120,
  viewBox: "0 0 120 120",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(2 -449.854 493.004)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 11.454)"
}, /*#__PURE__*/React.createElement("rect", {
  stroke: "#000",
  strokeWidth: 4,
  x: 2,
  y: 18.546,
  width: 86,
  height: 52,
  rx: 9
}), /*#__PURE__*/React.createElement("path", {
  d: "m45.058 0 .266.006a8.964 8.964 0 0 1 6.366 2.973L67.5 20.546h-45L38.31 2.979A8.975 8.975 0 0 1 44.793.002L45.058 0zm-3.435 5.313-.173.166-.167.176-9.801 10.89h27.037l-9.803-10.89a5 5 0 0 0-.18-.19l-.191-.182a5 5 0 0 0-6.722.03z",
  fill: "#000",
  fillRule: "nonzero"
})), /*#__PURE__*/React.createElement("circle", {
  fill: "var(--theme-primary, #810ea9)",
  cx: 45.5,
  cy: 9,
  r: 9
}), /*#__PURE__*/React.createElement("path", {
  d: "M42.755 45.264a2.407 2.407 0 0 1 1.492 2.218v1.583c7.705.589 13.677 6.901 13.753 14.539a13.763 13.763 0 0 1-.424 3.368 1.364 1.364 0 0 1-1.232 1.025l-.117.002-.115-.002a1.364 1.364 0 0 1-1.232-1.025c-1.263-4.945-5.538-8.568-10.674-9.048v1.514c0 .969-.589 1.843-1.492 2.218-.979.445-2.13.28-2.942-.419l-6.925-5.964A2.369 2.369 0 0 1 32 53.46c0-.697.31-1.36.847-1.812l6.925-5.978a2.763 2.763 0 0 1 2.983-.406z",
  fill: "var(--theme-primary, #810ea9)",
  fillRule: "nonzero"
}))));

      const __svgRaw = "\t\t\r\n   <svg width='120' height='120' viewBox='0 0 120 120' xmlns='http://www.w3.org/2000/svg'>\r\n                  <g transform='rotate(2 -449.854 493.004)' fill='none' fill-rule='evenodd'>\r\n                    <g transform='translate(0 11.454)'>\r\n                      <rect stroke='#000' stroke-width='4' x='2' y='18.546' width='86' height='52' rx='9' />\r\n                      <path\r\n                        d='m45.058 0 .266.006a8.964 8.964 0 0 1 6.366 2.973L67.5 20.546h-45L38.31 2.979A8.975 8.975 0 0 1 44.793.002L45.058 0zm-3.435 5.313-.173.166-.167.176-9.801 10.89h27.037l-9.803-10.89a5 5 0 0 0-.18-.19l-.191-.182a5 5 0 0 0-6.722.03z'\r\n                        fill='#000'\r\n                        fill-rule='nonzero'\r\n                      />\r\n                    </g>\r\n                    <circle fill=\"var(--theme-primary, #810ea9)\" cx='45.5' cy='9' r='9' />\r\n                    <path\r\n                      d='M42.755 45.264a2.407 2.407 0 0 1 1.492 2.218v1.583c7.705.589 13.677 6.901 13.753 14.539a13.763 13.763 0 0 1-.424 3.368 1.364 1.364 0 0 1-1.232 1.025l-.117.002-.115-.002a1.364 1.364 0 0 1-1.232-1.025c-1.263-4.945-5.538-8.568-10.674-9.048v1.514c0 .969-.589 1.843-1.492 2.218-.979.445-2.13.28-2.942-.419l-6.925-5.964A2.369 2.369 0 0 1 32 53.46c0-.697.31-1.36.847-1.812l6.925-5.978a2.763 2.763 0 0 1 2.983-.406z'\r\n                      fill=\"var(--theme-primary, #810ea9)\"\r\n                      fill-rule='nonzero'\r\n                    />\r\n                  </g>\r\n                </svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/error.393931895f8c7fe2279401753be47463.svg"),
        {
          React: SvgError,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      